import LocationBadge from "../components/LocationBadge";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-hot-toast";
import api, { ApiResponse, getCodes } from "../services/api";
import { getCategories } from "../services/api";
import { useNavigate } from "react-router-dom";
import vegIcon from "../assests/Veg_symbol.png";
import nonvegIcon from "../assests/Non_veg_symbol.png";
import LoyaltyBar from "../components/Loyaltybar";
import { getPlatformLogo } from "../services/api";
// import "../styles/EmpPos.css";
import carticon from "../assests/carticon.svg";
import { useOrder, OrderItem } from "./EmpOrderContext";
import VideoLoader from "../components/VideoLoader";
import { TaxesProps, useAuth } from "../context/AuthContext";
import { Printer, ShoppingCart } from "lucide-react";
import { logout } from "../utils/auth";
import PrinterSettings from "../components/PrinterSettings";
import { getBluetoothPrinterName, isBluetoothSupported } from "../pages/pos/bluetoothPrinter";
import Cookies from "js-cookie";
interface MenuItem {
  _id: string;
  name: string;
  kitchenName?: string;
  description?: string;
  price: number;
  category: string;
  categoryId: string;
  additionalCategoryIds?: string[];
  categoryCode?: string;
  imageUrl?: string;
  customize: CustomizeGroup[];
  tags?: string[];
  foodType: "veg" | "non-veg" | "both";
}

interface CustomizeChoice {
  label: string;
  price: number;
  image?: string;
  default?: boolean;
}

interface PortionOption {
  key: string;
  label: string;
  icon?: string;
}

interface CustomizeGroup {
  name: string;
  required: boolean;
  multiple?: boolean;
  multipleAddons?: boolean;
  choices: CustomizeChoice[];
  noOfFreeToppings?: number;
  maxToppingsAllowed?: number;
  minAddons?: number;
  displayType?: "checkbox" | "quantity" | "portion" | "radio";
  quantityOptions?: number[];
  portionOptions?: PortionOption[];
  showPortionSelector?: boolean;
}

interface LoyaltyCustomer {
  _id: string;
  customerId: string;
  phoneNumber: number;
  points: number;
}

interface CartItem {
  item: MenuItem;
  quantity: number;
}
interface Category {
  name: string;
  _id: string;
  categoryCode: string;
  imageUrl: string;
}
interface CustomSelectionsWithSections {
  [key: string]: number | string;
}

// Rotating palette for the category tile grid (cycled by index)
const CATEGORY_TILE_COLORS = [
  "bg-[#6b4a35]",
  "bg-[#1c1c1c]",
  "bg-[#8a6a4a]",
  "bg-[#1c1c1c]",
  "bg-[#1c1c1c]",
  "bg-[#2f6b2f]",
  "bg-[#d92b2b]",
  "bg-[#2f8fd9]",
  "bg-[#1c1c1c]",
  "bg-[#8a6a4a]",
  "bg-[#1c1c1c]",
];

// Pizza Icons component matching the screenshot design
const PizzaIcons = {
  left: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="w-4 h-4"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        fill="white"
      />
      <path d="M8 1.5 L8 14.5" stroke="currentColor" strokeWidth="0.8" />
      <path
        d="M1.5 8 A6.5 6.5 0 0 1 8 1.5 L8 14.5 A6.5 6.5 0 0 1 1.5 8"
        fill="currentColor"
      />
    </svg>
  ),
  right: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="w-4 h-4"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        fill="white"
      />
      <path d="M8 1.5 L8 14.5" stroke="currentColor" strokeWidth="0.8" />
      <path
        d="M14.5 8 A6.5 6.5 0 0 1 8 14.5 L8 1.5 A6.5 6.5 0 0 1 14.5 8"
        fill="currentColor"
      />
    </svg>
  ),
  whole: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="w-4 h-4"
    >
      <circle
        cx="8"
        cy="8"
        r="6.5"
        stroke="currentColor"
        strokeWidth="1"
        fill="currentColor"
      />
    </svg>
  ),
};
const computeFreeToppingDiscount = (
  item: MenuItem,
  selections: Record<string, number | string>,
): number => {
  let total = 0;
  for (const group of item.customize) {
    if (group.required || group.multiple) continue;
    const freeToppings = group.noOfFreeToppings ?? 0;
    if (!freeToppings) continue;
    let freeRemaining = freeToppings;
    for (const choice of group.choices) {
      if (freeRemaining <= 0) break;
      if (choice.default) continue;
      const key = `${group.name}|||${choice.label}`;
      const qty = Number(selections[key] || 0);
      if (qty > 0) {
        const freeQty = Math.min(qty, freeRemaining);
        total += (choice.price || 0) * freeQty;
        freeRemaining -= freeQty;
      }
    }
  }
  return total;
};

const EmpPos: React.FC = () => {
  const [menuItems, setMenuItems] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [tableToken, setTableToken] = useState<number | "">("");
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [categories, setCategories] = useState<Category[]>([]);
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState<MenuItem | null>(null);
  const [points, setPoints] = useState<number>(0);
  const [showModal, setShowModal] = useState(false);
  const [showPrinterSettings, setShowPrinterSettings] = useState(
    () => isBluetoothSupported() && !getBluetoothPrinterName(),
  );
  const [employeeName, setEmployeeName] = useState<string | null>(null);
  const [mobileCartVisible, setMobileCartVisible] = useState(false);
  const [discount, setDiscount] = useState<number | null>(null);
  const handleDiscountChange = (newDiscount: number) => {
    setDiscount(newDiscount);
  };
  const [logoUrl, setLogoUrl] = useState<string>("");
  const [isLogoLoaded, setIsLogoLoaded] = useState(true);
  const [resetSelections, setResetSelections] = useState(0);
  const { setCategoryCodes, setTaxes, categoryCodes, taxes, currencySymbol } = useAuth();
  const [showcustModal, setShowcustModal] = useState(false);
  const [collapsedGroups, setCollapsedGroups] = useState<Record<string, boolean>>({});
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [selectedCustomizeItem, setSelectedCustomizeItem] =
    useState<MenuItem | null>(null);
  const {
    orderData,
    setOrderData,
    user,
    logoUrl: orderLogoUrl,
    setLogoUrl: setOrderLogoUrl,
  } = useOrder();
  const cart = orderData?.items || [];
  const [customizingItem, setCustomizingItem] = useState<OrderItem | null>(
    null,
  );
  const [selectedchoice, setSelectedchoice] = useState<
    "veg" | "non-veg" | null
  >(null);
  // State to track if "Schedule" is selected
  const [isScheduled, setIsScheduled] = useState<boolean>(false);
  const [scheduledAt, setScheduledAt] = useState<string>("");
  const [currentDateTime, setCurrentDateTime] = useState<string>("");

  useEffect(() => {
    // Get the current date and time in ISO format (YYYY-MM-DDTHH:MM)
    const now = new Date().toISOString().slice(0, 16);
    setCurrentDateTime(now); // Set current date-time as state
  }, []);
  useEffect(() => {
    if (!selectedCustomizeItem || customizingItem) return;

    const defaults: Record<string, number> = {};
    selectedCustomizeItem.customize.forEach((group: any) => {
      const quantityOptions = group.quantityOptions?.length
        ? group.quantityOptions
        : [0, 1, 2, 3];
      const hasDefaultOffset = quantityOptions[0] < 0;

      group.choices
        .filter((c: any) => c.default)
        .forEach((defaultChoice: any) => {
          const key = `${group.name}|||${defaultChoice.label}`;
          defaults[key] = hasDefaultOffset ? 0 : 1;
        });
    });

    setCustomSelections(defaults); // reset fresh, don’t merge
  }, [selectedCustomizeItem, resetSelections]);
  const [customSelections, setCustomSelections] =
    useState<CustomSelectionsWithSections>({});

  const customizationGroupRefs = useRef<Record<string, HTMLDivElement | null>>(
    {},
  );
  const pendingScrollGroupIndexRef = useRef<number | null>(null);
  const handleChoiceChange = (key: string, newQty: number) => {
    setCustomSelections((prev) => {
      const nextQty = Math.max(newQty, -1);
      const nextSelections = { ...prev, [key]: nextQty };
      if (!selectedCustomizeItem) return nextSelections;

      const [groupName, choiceLabel] = key.split("|||");
      const groupIndex = selectedCustomizeItem.customize.findIndex(
        (group) => group.name === groupName,
      );
      if (groupIndex < 0) return nextSelections;

      const group = selectedCustomizeItem.customize[groupIndex];
      const choice = group.choices.find((c) => c.label === choiceLabel);
      const maxToppings = group.maxToppingsAllowed ?? 0;
      if (!choice || choice.default || maxToppings <= 0) return nextSelections;

      const getGroupTotal = (selections: CustomSelectionsWithSections) =>
        group.choices.reduce((sum, c) => {
          if (c.default) return sum;
          return (
            sum + Math.max(0, Number(selections[`${group.name}|||${c.label}`] || 0))
          );
        }, 0);

      const prevTotal = getGroupTotal(prev);
      const nextTotal = getGroupTotal(nextSelections);
      if (
        prevTotal < maxToppings &&
        nextTotal >= maxToppings &&
        groupIndex < selectedCustomizeItem.customize.length - 1
      ) {
        pendingScrollGroupIndexRef.current = groupIndex + 1;
      }

      return nextSelections;
    });
  };

  const getLogo = async () => {
    const logo = await getPlatformLogo();
    if (logo.data.success && logo.data.data?.logo) {
      console.log("Fetched platform logo:", logo.data.data.logo);
      setIsLogoLoaded(false);
      setLogoUrl(logo.data.data.logo);
    } else {
      setLogoUrl("");
      setIsLogoLoaded(true);
    }
  };

  useEffect(() => {
    getLogo();
  }, []);

  useEffect(() => {
    if (!logoUrl) {
      setIsLogoLoaded(true);
      return;
    }

    let isActive = true;
    setIsLogoLoaded(false);

    const img = new Image();
    img.src = logoUrl;
    img.onload = () => {
      if (isActive) {
        setIsLogoLoaded(true);
      }
    };
    img.onerror = () => {
      if (isActive) {
        setLogoUrl("");
        setIsLogoLoaded(true);
      }
    };

    return () => {
      isActive = false;
    };
  }, [logoUrl]);

  const showLogo = Boolean(logoUrl);

  const hasRequiredSelection = useCallback(
    (group: CustomizeGroup) => {
      return group.choices.some((choice) => {
        const key = `${group.name}|||${choice.label}`;
        const qty = Number(customSelections[key] || 0);
        const quantityOptions = group.quantityOptions?.length
          ? group.quantityOptions
          : [0, 1, 2, 3];
        const isDefaultWithOffset = !!choice.default && quantityOptions[0] < 0;

        return isDefaultWithOffset ? qty >= 0 : qty > 0;
      });
    },
    [customSelections],
  );

  const firstMissingRequiredGroupIndex = useMemo(() => {
    if (!selectedCustomizeItem) return -1;

    return selectedCustomizeItem.customize.findIndex((group) => {
      if (group.required && !hasRequiredSelection(group)) return true;
      const minAddons = group.minAddons ?? 0;
      if (minAddons > 0) {
        const totalSelected = group.choices.reduce((sum, c) => {
          if (c.default) return sum;
          return sum + Math.max(0, Number(customSelections[`${group.name}|||${c.label}`] || 0));
        }, 0);
        if (totalSelected < minAddons) return true;
      }
      return false;
    });
  }, [selectedCustomizeItem, hasRequiredSelection, customSelections]);

  const isCustomizationValid = firstMissingRequiredGroupIndex === -1;

  const focusFirstMissingRequiredGroup = useCallback(() => {
    if (firstMissingRequiredGroupIndex < 0) return;
    const refKey = `group-${firstMissingRequiredGroupIndex}`;
    const el = customizationGroupRefs.current[refKey];
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [firstMissingRequiredGroupIndex]);
  useEffect(() => {
    const pendingGroupIndex = pendingScrollGroupIndexRef.current;
    if (pendingGroupIndex === null) return;
    pendingScrollGroupIndexRef.current = null;

    const nextGroupEl =
      customizationGroupRefs.current[`group-${pendingGroupIndex}`];
    if (nextGroupEl) {
      nextGroupEl.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [customSelections]);
  const handleHalfHalfSelection = (
    choiceKey: string,
    section: "left" | "right" | "whole",
  ) => {
    const currentSection =
      (customSelections[`${choiceKey}_section`] as string) || "";
    const currentQuantity = (customSelections[choiceKey] as number) || 0;
    const [groupName, choiceLabel] = choiceKey.split("|||");
    const group = selectedCustomizeItem?.customize.find(
      (g) => g.name === groupName,
    );
    const choice = group?.choices.find((c) => c.label === choiceLabel);
    const quantityOptions = group?.quantityOptions?.length
      ? group.quantityOptions
      : [0, 1, 2, 3];
    const hasDefaultOffset = !!choice?.default && quantityOptions[0] < 0;
    const minQuantityForSection = hasDefaultOffset ? 0 : 1;
    let newSection: string = "";

    if (currentSection === section) {
      // If clicking the same section, deselect it
      newSection = "";
    } else {
      // If clicking a different section, select it directly
      newSection = section;
    }

    setCustomSelections((prev) => ({
      ...prev,
      [`${choiceKey}_section`]: newSection,
      [choiceKey]: newSection
        ? Math.max(currentQuantity, minQuantityForSection)
        : currentQuantity,
    }));
  };
  const fetchHotelInfo = async () => {
    try {
      const { data } = await api.get<ApiResponse<{ taxes: [TaxesProps] }>>(
        `/admin/getTaxInfo/${user?.restaurantId || ""}`,
      );
      if (data.success && data.data) {
        // You can store taxRate in state or context if needed
        console.log("Fetched hotel tax rate:", data.data.taxes);
        setTaxes(data.data.taxes);
      }
    } catch (error) {
      console.error("Failed to fetch hotel info", error);
    }
  };
  const fetchCodes = async () => {
    const res = await getCodes();
    setCategoryCodes(res.data);
  };
  useEffect(() => {
    //on load of App get hotel address from env and then call API to get Tax information
    fetchHotelInfo();
    fetchCodes();
  }, []);

  // modal remember choice
  const buildSelectionsFromOptions = (
    menuItem: MenuItem | undefined,
    options: {
      label: string;
      price: number;
      qty: number;
      groupName?: string;
    }[] = [],
  ) => {
    if (!menuItem || !Array.isArray(options)) return {};
    const map: Record<string, number | string> = {};
    const labelUseCount: Record<string, number> = {};

     const isHalfHalfPizza = menuItem?.category
                  ?.toLowerCase()
                  .includes("pizza")
                  || menuItem.customize.some((grp) => grp.portionOptions);

    options.forEach((opt) => {
      let choiceLabel = opt.label;
      let section = "";

      // For Half & Half Pizza, extract section from label
      if (isHalfHalfPizza) {
        const sections = ["left", "right", "whole"];
        const foundSection = sections.find((s) =>
          opt.label.toLowerCase().endsWith(` ${s}`),
        );

        if (foundSection) {
          section = foundSection;
          choiceLabel = opt.label
            .replace(new RegExp(` ${foundSection}$`, "i"), "")
            .trim();
        }
      }

      let group =
        opt.groupName &&
        menuItem.customize.find(
          (g) =>
            g.name === opt.groupName &&
            g.choices.some((c) => c.label === choiceLabel),
        );

      if (!group) {
        const candidateGroups = menuItem.customize.filter((g) =>
          g.choices.some((c) => c.label === choiceLabel),
        );

        if (candidateGroups.length > 0) {
          const used = labelUseCount[choiceLabel] || 0;
          group = candidateGroups[Math.min(used, candidateGroups.length - 1)];
          labelUseCount[choiceLabel] = used + 1;
        }
      }

      if (group) {
        const key = `${group.name}|||${choiceLabel}`;
        map[key] = opt.qty;

        // Set section for Half & Half Pizza
        if (isHalfHalfPizza && section) {
          map[`${key}_section`] = section;
        }
      }
    });

    return map;
  };

  // Show modal when an item is clicked
  const handleItemClick = (item: MenuItem) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null); // Reset selected item
  };
  const handleLogout = () => {
    Cookies.remove("emptoken");
    Cookies.remove("employeeUsername");
    navigate("/login");
  };
  // Set employee name
  useEffect(() => {
    setEmployeeName(user?.name || "EMPLOYEE");
    fetchMenuItems();
    fetchCategories();
  }, [user]); // Add user as dependency

  //scroll smooth
  // useEffect(() => {
  //   if (menuRef.current) {
  //     menuRef.current.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //   }
  // }, [selectedCategory]);

  const fetchMenuItems = async (foodType?: string | null) => {
    try {
      setLoading(true);
      setError(null);

      // Build URL with query parameters
      const params = new URLSearchParams();
      if (foodType) {
        params.append("foodType", foodType);
      }
      if (user?.restaurantId) {
        params.append("restaurantId", user.restaurantId);
      }
      const url = params.toString() ? `/menu?${params.toString()}` : "/menu";

      const { data } = await api.get<ApiResponse<MenuItem[]>>(url);
      if (data.success && Array.isArray(data.data)) {
        setMenuItems(data.data);
      } else {
        setMenuItems([]);
        setError("Failed to load menu.");
      }
    } catch {
      setMenuItems([]);
      setError("Failed to load menu.");
    } finally {
      setLoading(false);
    }
  };

  // Add this useEffect to refetch when selectedchoice or user changes
  useEffect(() => {
    fetchMenuItems(selectedchoice);
  }, [selectedchoice, user?.restaurantId]);

  // modal data passing
  const handleCustomSubmit = () => {
    if (!selectedCustomizeItem) return;
            const isHalfHalfPizza = selectedCustomizeItem.category
                  ?.toLowerCase()
                  .includes("pizza")
                  || selectedCustomizeItem.customize.some((grp) => grp.portionOptions);

    let extraPrice = 0;

    const selectedOptions = selectedCustomizeItem.customize.flatMap((group) =>
      group.choices
        .map((choice) => {
          const key = `${group.name}|||${choice.label}`;
          const qty = (customSelections[key] as number) || 0;
          const section = customSelections[`${key}_section`] as string;

          if (qty === -1 || qty > 0) {
            const label =
              isHalfHalfPizza && section
                ? `${choice.label} ${section}`
                : choice.label;
            const quantityOptions = group.quantityOptions?.length
              ? group.quantityOptions
              : [0, 1, 2, 3];
            const hasDefaultOffset = !!choice.default && quantityOptions[0] < 0;
            const chargeableQty = choice.default
              ? hasDefaultOffset
                ? Math.max(0, qty)
                : Math.max(0, qty - 1)
              : Math.max(0, qty);

            extraPrice += (choice.price || 0) * chargeableQty;

            return {
              label,
              price: choice.price,
              qty,
              groupName: group.name,
            };
          }
          return null;
        })
        .filter(
          (
            c,
          ): c is {
            label: string;
            price: number;
            qty: number;
            groupName: string;
          } => c !== null,
        ),
    );

    // Apply free toppings discount
    const freeToppingDiscount = computeFreeToppingDiscount(
      selectedCustomizeItem,
      customSelections,
    );
    extraPrice = Math.max(0, extraPrice - freeToppingDiscount);

    let newCart: OrderItem[];
    // Calculate Taxes
    let taxRate = 0;
    let gstRate = 0;
    let pstRate = 0;

    if (categoryCodes) {
      // Use item's own categoryCode override if set, else fall back to category's code
      let effectiveCategoryCodeId = selectedCustomizeItem.categoryCode;
      if (!effectiveCategoryCodeId) {
        const filteredCode = categories.filter((item) => item._id == selectedCustomizeItem.categoryId);
        if (filteredCode.length > 0) {
          effectiveCategoryCodeId = filteredCode[0].categoryCode;
        }
      }
      if (effectiveCategoryCodeId) {
        const categoryCodeFilter = categoryCodes.filter((item) => item._id == effectiveCategoryCodeId);
        if (categoryCodeFilter.length > 0) {
          const taxItem = taxes?.filter((item) => item.category_code == categoryCodeFilter[0].code);
          if (taxItem && taxItem.length > 0) {
            const t = taxItem[0];
            if (t.gst != null || t.pst != null) {
              gstRate = Number(t.gst ?? 0);
              pstRate = Number(t.pst ?? 0);
            } else {
              taxRate = Number(t.tax_percent ?? 0);
            }
          }
        }
      }
    }

    const isCanada = gstRate > 0 || pstRate > 0;
    const calcTax = (price: number) => ({
      tax: isCanada ? 0 : Number(((price * taxRate) / 100).toFixed(2)),
      gst: isCanada ? Number(((price * gstRate) / 100).toFixed(2)) : undefined,
      pst: isCanada ? Number(((price * pstRate) / 100).toFixed(2)) : undefined,
    });

    if (customizingItem) {
      // ✅ Update the existing cart entry
      newCart = cart.map((c) => {
        if (c.cartId !== customizingItem.cartId) return c;
        const itemPrice = selectedCustomizeItem.price + extraPrice;
        return {
          ...c,
          price: itemPrice,
          customOptions: selectedOptions,
          ...calcTax(itemPrice),
        };
      });
    } else {
      // ✅ Add new item or merge with existing identical customization
      const existing = cart.find(
        (c) =>
          c.itemId === selectedCustomizeItem._id &&
          JSON.stringify(c.customOptions) === JSON.stringify(selectedOptions),
      );

      if (existing) {
        newCart = cart.map((c) =>
          c.cartId === existing.cartId ? { ...c, quantity: c.quantity + 1 } : c,
        );
      } else {
        const itemPrice = selectedCustomizeItem.price + extraPrice;
        newCart = [
          ...cart,
          {
            itemId: selectedCustomizeItem._id,
            name: selectedCustomizeItem.name,
            kitchenName: selectedCustomizeItem.kitchenName,
            price: itemPrice,
            ...calcTax(itemPrice),
            categoryId: selectedCustomizeItem.categoryId,
            cartId:
              Date.now().toString() +
              Math.random().toString(36).substring(2, 9),
            quantity: 1,
            imageUrl: selectedCustomizeItem.imageUrl,
            customOptions: selectedOptions,
          },
        ];
      }
    }
    setResetSelections((c) => c + 1);
    setOrderData((prev) => ({ ...prev, items: newCart }));
    setShowcustModal(false);
    setCustomSelections({});
    setCustomizingItem(null); // reset editing state
  };

  const removeFromCart = (cartId: string) => {
    const newCart = cart.filter((c) => c.cartId !== cartId);
    setOrderData((prev) => ({ ...prev, items: newCart }));
  };

  const fetchCategories = async () => {
    try {
      const res = await getCategories(); // Assuming this fetches data from the API
      if (res.data.success) {
        const categoriesWithImages = res.data.data.map(
          (cat: {
            name: string;
            imageUrl: string;
            _id: string;
            categoryCode: any;
          }) => ({
            name: cat.name,
            imageUrl: cat.imageUrl,
            _id: cat._id,
            categoryCode: typeof cat.categoryCode === "object" ? cat.categoryCode?._id ?? "" : cat.categoryCode ?? "",
          }),
        );
        setCategories(categoriesWithImages);
        if (!selectedCategory && categoriesWithImages.length > 0) {
          setSelectedCategory(categoriesWithImages[0].name);
        }
      }
    } catch (err) {
      console.error("Failed to fetch categories", err);
    }
  };
  const updateQuantity = (cartId: string, quantity: number) => {
    if (quantity < 1) return removeFromCart(cartId);
    const newCart = cart.map((c) =>
      c.cartId === cartId ? { ...c, quantity } : c,
    );
    setOrderData((prev) => ({ ...prev, items: newCart }));
  };
  const getItemQty = (itemId: string) => {
    return cart
      .filter((c) => c.itemId === itemId)
      .reduce((total, c) => total + c.quantity, 0);
  };

  const fetchPoints = async (phoneNumber: string) => {
    if (!phoneNumber) return;
    try {
      const { data } = await api.get<ApiResponse<LoyaltyCustomer>>(
        `/loyalty/${phoneNumber}`,
      );
      if (data.success && data.data) {
        setPoints(data.data.points);
      } else {
        setPoints(0); // In case no points are found
      }
    } catch (error) {
      setPoints(0); // In case of error, reset points to 0
    }
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let input = e.target.value;

    // Remove all non-digit and non-dash characters
    const cleaned = input.replace(/[^\d-]/g, "");

    // Extract just the digits for validation and API call
    const digits = cleaned.replace(/-/g, "").slice(0, 10); // Only 10 digits max

    let formatted = "";

    // Check if user manually typed dashes in correct positions only
    const validManualFormat =
      /^\d{1,3}$|^\d{3}-\d{0,3}$|^\d{3}-\d{3}-\d{0,4}$/.test(cleaned);

    if (validManualFormat && cleaned === input.replace(/[^\d-]/g, "")) {
      // User typed valid format with dashes in correct positions, keep it
      formatted = cleaned;
    } else {
      // Auto-format based on digit count
      if (digits.length > 6) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(
          6,
        )}`;
      } else if (digits.length > 3) {
        formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
      } else {
        formatted = digits;
      }
    }

    setPhoneNumber(formatted);

    // Trigger fetchPoints only if there are exactly 10 digits
    if (digits.length === 10) {
      fetchPoints(digits);
    } else {
      setPoints(0);
      setDiscount(0);
    }
  };

  //Category Scroller

  // Category names an item is listed under: its primary category plus any additional ones
  const getItemCategoryNames = useCallback(
    (item: MenuItem): string[] => {
      const names = new Set<string>();
      if (item.category && item.category.trim() !== "") names.add(item.category);
      (item.additionalCategoryIds || []).forEach((id) => {
        const cat = categories.find((c) => c._id === id);
        if (cat) names.add(cat.name);
      });
      return Array.from(names);
    },
    [categories],
  );

  // Group menu items by category
  const groupedMenuItems = useMemo(() => {
    const grouped: { [key: string]: MenuItem[] } = {};

    // First, group all items by category
    menuItems.forEach((item) => {
      getItemCategoryNames(item).forEach((categoryName) => {
        if (!grouped[categoryName]) {
          grouped[categoryName] = [];
        }
        grouped[categoryName].push(item);
      });
    });

    // Then sort by category order (matching the categories array order)
    const sortedGrouped: { [key: string]: MenuItem[] } = {};
    categories.forEach((cat) => {
      if (grouped[cat.name]) {
        sortedGrouped[cat.name] = grouped[cat.name];
      }
    });

    // Add any remaining categories not in the categories array
    Object.keys(grouped).forEach((cat) => {
      if (!sortedGrouped[cat]) {
        sortedGrouped[cat] = grouped[cat];
      }
    });

    return sortedGrouped;
  }, [menuItems, categories, getItemCategoryNames]);
  const menuRef = useRef<HTMLDivElement>(null);

  const categorySectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {},
  );
  const categoryHeaderRefs = useRef<{ [key: string]: HTMLDivElement | null }>(
    {},
  );
  const scrollTimeout = useRef<NodeJS.Timeout | null>(null);
  const isManualScrolling = useRef(false); // 👈 NEW flag
  const [stickyStates, setStickyStates] = useState<{ [key: string]: boolean }>(
    {},
  );
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const categoryName = entry.target.getAttribute(
            "data-category-header",
          );
          if (categoryName) {
            // Jab header top se chipak jaye (sticky ho), isIntersecting false hoga
            setStickyStates((prev) => ({
              ...prev,
              [categoryName]: !entry.isIntersecting,
            }));
          }
        });
      },
      {
        threshold: [1],
        rootMargin: "-1px 0px 0px 0px",
      },
    );

    // Observe all category headers
    Object.values(categoryHeaderRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, [groupedMenuItems]);

  const handleChange = (e: any) => {
    const value = e.target.value;
    if (value === "" || (Number(value) >= 1 && Number(value) <= 20)) {
      setTableToken(value);
    }
  };

  useEffect(() => {
    if (!menuRef.current) return;

    const observerOptions = {
      root: menuRef.current,
      rootMargin: "-80px 0px -60% 0px", // Account for sticky header height
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      if (isManualScrolling.current) return;

      // Find the entry with the highest intersection ratio
      let mostVisible = {
        entry: null as IntersectionObserverEntry | null,
        ratio: 0,
      };

      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          entry.intersectionRatio > mostVisible.ratio
        ) {
          mostVisible = { entry, ratio: entry.intersectionRatio };
        }
      });

      if (mostVisible.entry) {
        const categoryName = mostVisible.entry.target.getAttribute(
          "data-category-section",
        );
        if (categoryName) {
          setSelectedCategory(categoryName);
        }
      }
    }, observerOptions);

    Object.values(categorySectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, [groupedMenuItems]);

  // Function to handle category selection - scrolls to first item of that category
  const handleCategorySelect = (categoryName: string) => {
    const sectionElement = categorySectionRefs.current[categoryName];

    if (sectionElement && menuRef.current) {
      // Get the position we need to scroll to
      const menuTop = menuRef.current.getBoundingClientRect().top;
      const sectionTop = sectionElement.getBoundingClientRect().top;

      // Calculate scroll position: section top relative to menu container top
      // Add a small offset to ensure the section starts right at the top
      const scrollTop = sectionTop - menuTop + menuRef.current.scrollTop;

      // Pause observer updates
      isManualScrolling.current = true;

      menuRef.current.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });

      // Clear any existing timeout
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      // When scroll stops, allow observer again
      const handleScrollEnd = () => {
        if (scrollTimeout.current) {
          clearTimeout(scrollTimeout.current);
        }
        scrollTimeout.current = setTimeout(() => {
          isManualScrolling.current = false;
        }, 150);
      };

      menuRef.current.addEventListener("scroll", handleScrollEnd, {
        once: false,
      });

      // Safety timeout
      setTimeout(() => {
        menuRef.current?.removeEventListener("scroll", handleScrollEnd);
        isManualScrolling.current = false;
      }, 1200);
    }

    setSelectedCategory(categoryName);
  };
  const subtotal = useMemo(
    () => cart.reduce((t, i) => t + i.price * i.quantity, 0),
    [cart],
  );
  const getItemTotalTax = useCallback(
    (item: OrderItem) =>
      Number(item.tax ?? 0) + Number(item.gst ?? 0) + Number(item.pst ?? 0),
    [],
  );
  const totalAmount = useMemo(
    () => cart.reduce((t, i) => t + (i.price + getItemTotalTax(i)) * i.quantity, 0),
    [cart, getItemTotalTax],
  );
  const totalTax = useMemo(
    () => cart.reduce((t, i) => t + getItemTotalTax(i) * i.quantity, 0),
    [cart, getItemTotalTax],
  );
  const discountAmount = useMemo(
    () => (subtotal * (discount ?? 0)) / 100,
    [subtotal, discount],
  );
  const grandTotal = useMemo(
    () => totalAmount - discountAmount,
    [totalAmount, discountAmount],
  );


  const handleCheckout = async () => {
    if (cart.length === 0) {
      toast.error("Cart is empty");
      return;
    }
    if (!phoneNumber) {
      toast.error("Please enter a valid phone number");
      return;
    }
    if (phoneNumber.length < 10) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }
    const cleanPhoneNumber = phoneNumber.replace(/-/g, "");

    if (!tableToken && !scheduledAt) {
      toast.error("Please select a table token.");
      return;
    }

    const orderBy = employeeName ? "employee" : "customer";

    setLoading(true);
    try {
      const totalString = grandTotal.toFixed(2);

      // build the order object once
      const orderPayload = {
        ...orderData, // keep any existing stuff
        items: cart.map(
          ({
            itemId,
            name,
            kitchenName,
            price,
            quantity,
            imageUrl,
            customOptions,
            tax,
            gst,
            pst,
            categoryId,
          }) => ({
            itemId,
            name,
            kitchenName,
            price,
            categoryId,
            quantity,
            tax: Number(tax ?? 0),
            gst: Number(gst ?? 0),
            pst: Number(pst ?? 0),
            cartId:
              Date.now().toString() +
              Math.random().toString(36).substring(2, 9),
            imageUrl,
            customOptions: customOptions || [],
          }),
        ),
        totalAmount: totalString,
        discountAmount: discountAmount?.toFixed(2) || "0.00",
        phoneNumber: cleanPhoneNumber || "",
        tableToken,
        restaurantId: user?.restaurantId || "",
        orderBy,
        discountval,
        employeeName,
        scheduledAt: scheduledAt || undefined,
      };

      setOrderData(orderPayload);

      const { data } = await api.post<ApiResponse<any>>(
        "/orders",
        orderPayload,
      );

      if (data.success) {
        navigate(`/sos/confirmation/${data.data._id}`);
        setOrderData(null);
      } else {
        toast.error(data.error || "Failed to place order");
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.error || "Failed to place order");
    } finally {
      setLoading(false);
    }
  };

  const filteredMenu = selectedCategory
    ? menuItems.filter((item) => getItemCategoryNames(item).includes(selectedCategory))
    : menuItems;

  const getItemTaxRate = useCallback(
    (menuItem: MenuItem): number => {
      if (!categoryCodes) return 0;

      let effectiveCategoryCodeId = menuItem.categoryCode;
      if (!effectiveCategoryCodeId) {
        const category = categories.find((c) => c._id === menuItem.categoryId);
        effectiveCategoryCodeId = category?.categoryCode;
      }

      if (!effectiveCategoryCodeId) return 0;

      const categoryCode = categoryCodes.find(
        (c) => c._id === effectiveCategoryCodeId,
      );
      if (!categoryCode) return 0;

      const taxItem = taxes?.find(
        (item) => item.category_code === categoryCode.code,
      );
      if (!taxItem) return 0;
      return taxItem.gst != null || taxItem.pst != null
        ? Number(taxItem.gst ?? 0) + Number(taxItem.pst ?? 0)
        : Number(taxItem.tax_percent ?? 0);
    },
    [categories, categoryCodes, taxes],
  );

  // const handleAddToCart = useCallback(
  //   (item: MenuItem) => {
  //     const taxRate = getItemTaxRate(item);
  //     const itemTax = Number(((item.price * taxRate) / 100).toFixed(2));

  //     setOrderData((prev) => {
  //       const prevItems = prev?.items || [];
  //       const existing = prevItems.find(
  //         (c) =>
  //           c.itemId === item._id &&
  //           (!c.customOptions || c.customOptions.length === 0),
  //       );

  //       const newItems = existing
  //         ? prevItems.map((c) =>
  //             c.cartId === existing.cartId
  //               ? { ...c, quantity: c.quantity + 1 }
  //               : c,
  //           )
  //         : [
  //             ...prevItems,
  //             {
  //               itemId: item._id,
  //               name: item.name,
  //               kitchenName: item.kitchenName,
  //               price: item.price,
  //               categoryId: item.categoryId,
  //               tax: itemTax,
  //               cartId:
  //                 Date.now().toString() +
  //                 Math.random().toString(36).substring(2, 9),
  //               quantity: 1,
  //               imageUrl: item.imageUrl,
  //               customOptions: [],
  //             },
  //           ];

  //       return {
  //         ...(prev || {}),
  //         items: newItems,
  //       };
  //     });
  //   },
  //   [getItemTaxRate, setOrderData],
  // );

  const handlecust = (item: MenuItem) => {
    const isCustomizable = item.customize && item.customize.length > 0;
    // If item is NOT customizable, add directly to cart
    // if (!isCustomizable) {
    //   void handleAddToCart(item);
    //   return;
    // }

    setSelectedCustomizeItem(item);
    setCustomizingItem(null);
    setCollapsedGroups({});
    setShowcustModal(true);
  };

  if (loading) {
    return (
      // <div className="fixed inset-0 flex items-center justify-center bg-white z-50">

      //   Loading menu...</div>;

      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <VideoLoader size="medium" />
      </div>
    );
  }

  const discountval = discountAmount;
  // console.log(`this is discount val ${discountval} EMP`);

  // Handle radio button change
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsScheduled(event.target.value === "schedule");
  };

  const spinnerStyle = `
    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      opacity: 1;
      width: 12px;
      height: 12px;
      gap: 10px;
      cursor: pointer;
      transform: scale(2);
      align-self: center;
    }
    
    input[type="number"] {
      padding-right: 40px;
    }
  `;

  const topBar = (
    <div className="border-b border-gray-200">
      <div className="h-[100px] px-4 md:px-6 flex items-center justify-between">
        <div className="w-[100px] flex items-center">
          {showLogo ? (
            <img
              src={logoUrl}
              alt="Platform logo"
              className="w-auto h-[85px] object-contain"
            />
          ) : (
            <div className="text-[26px] font-extrabold leading-none text-[#222]">
              Qleap
            </div>
          )}
        </div>

        <div className="flex items-center gap-2 sm:gap-4 md:gap-6 lg:gap-8">
          <button className="px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold bg-blue-600 text-white shadow-sm">
            POS
          </button>
          <button
            onClick={() => navigate("/Sales/all-orders")}
            className="px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold text-gray-500 hover:text-gray-800"
          >
            Orders
          </button>
        </div>
        <div className="min-w-[100px] flex items-center justify-end gap-2">
          <LocationBadge
            restaurantId={user?.restaurantId}
            className="max-w-[160px]"
          />
          <button
            onClick={handleLogout}
            className="px-3 sm:px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold text-white bg-red-600 hover:bg-red-700"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="h-screen overflow-hidden">
      {topBar}
      <div className="flex h-[calc(100vh-100px)]">
        {/* Menu Section */}
        {/* Menu Section with Category Tile Grid + Category Headers */}
        <div
          className="flex-[2] p-3 px-0 pt-0 overflow-y-auto bg-gray-100 no-scrollbar relative"
          ref={menuRef}
        >
          {error && (
            <div className="bg-red-600 text-white p-4 rounded-md mb-6">
              {error}
            </div>
          )}

          {/* Category Tiles - click scrolls down to that category's section below */}
          <div
            className="grid grid-cols-2 gap-2 sm:gap-2.5 md:gap-3 lg:gap-4 
              px-3 sm:px-4 md:px-6 lg:px-9 py-3 sm:py-4 md:py-6"
          >
            {categories.map((category, index) => {
              const isSelected = selectedCategory === category.name;
              return (
                <button
                  key={category.name}
                  onClick={() => handleCategorySelect(category.name)}
                  className={`text-left rounded-xl sm:rounded-2xl px-3 sm:px-4 md:px-5 
                    py-4 sm:py-5 md:py-6 font-bold text-white shadow-sm
                    text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px]
                    transition-transform hover:scale-[1.02] will-change-transform
                    ${CATEGORY_TILE_COLORS[index % CATEGORY_TILE_COLORS.length]}
                    ${isSelected ? "ring-4 ring-blue-400" : ""}`}
                >
                  {category.name}
                </button>
              );
            })}
          </div>

          {Object.keys(groupedMenuItems).length === 0 ? (
            <p className="text-gray-500">No menu items available.</p>
          ) : (
            <div className="space-y-0">
              {/* <div className="flex gap-3 p-2">
        <button
          onClick={() => setSelectedchoice(selectedchoice === "veg" ? null : "veg")}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all border-2
            ${selectedchoice === "veg"
              ? 'bg-green-50 border-green-600 text-green-700'
              : 'bg-white border-gray-200 text-gray-600 hover:border-gray-400'
            }
          `}
        >
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
            <rect x="1" y="1" width="14" height="14" stroke="#0F8A65" strokeWidth="1.5" fill="none"/>
            <circle cx="8" cy="8" r="4" fill="#0F8A65"/>
          </svg>
          <span>Veg</span>
        </button>
        <button
          onClick={() => setSelectedchoice(selectedchoice === "non-veg" ? null : "non-veg")}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all border-2
            ${selectedchoice === "non-veg"
              ? 'bg-red-50 border-red-600 text-red-700'
              : 'bg-white border-gray-200 text-gray-600 hover:border-gray-400'
            }
          `}
        >
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
            <rect x="1" y="1" width="14" height="14" stroke="#E74C3C" strokeWidth="1.5" fill="none"/>
            <circle cx="8" cy="8" r="4" fill="#E74C3C"/>
          </svg>
          <span>Non-Veg</span>
        </button>
      </div> */}
              {Object.entries(groupedMenuItems).map(
                ([categoryName, items], index) => {
                  const isLastCategory =
                    index === Object.keys(groupedMenuItems).length - 1;

                  return (
                    <div
                      key={categoryName}
                      className="category-section"
                      ref={(el) =>
                        (categorySectionRefs.current[categoryName] = el)
                      }
                      data-category-section={categoryName}
                      // style={isLastCategory ? { paddingBottom: '60vh' } : undefined}
                    >
                      {/* Category Header - Sticky */}
                      <div
                        ref={(el) =>
                          (categoryHeaderRefs.current[categoryName] = el)
                        }
                        data-category-header={categoryName}
                        className={` sticky top-0 z-20
                                      flex items-center justify-between bg-[#fbfbf8]    px-3 sm:px-4 md:px-6 lg:px-9 
                                 mb-3 sm:mb-4 md:mb-5 
                                      [&[data-top='false']_.filter-buttons]:hidden 
                                      
                                    ${
                                      stickyStates[categoryName]
                                        ? "bg-gray-100 max-sm:px-[3px] max-sm:py-2 py-2 "
                                        : "bg-gray-100 py-2 md:py-4 "
                                    }`}
                      >
                        <h2 className="text-3xl font-bold text-gray-900 ml-4">
                          {categoryName}
                        </h2>
                        {stickyStates[categoryName] && (
                          <div className="filter-buttons flex max-sm:gap-2 [.sticky:not(:first-child)_&]:hidden gap-1 sm:gap-2 md:gap-3">
                            {/* absolute right-3 top-0 z-50 */}
                            <button
                              onClick={() =>
                                setSelectedchoice(
                                  selectedchoice === "veg" ? null : "veg",
                                )
                              }
                              className={`
                                          flex items-center gap-0.5 sm:gap-1 md:gap-2 
                          px-2 py-0.5 sm:px-2.5 sm:py-1 md:px-3 md:py-1.5 lg:px-4 lg:py-2 whitespace-nowrap
                                  rounded-full font-medium transition-all border-[1px] text-[10px] sm:text-[11px] md:text-xs lg:text-sm
        
                                          ${
                                            selectedchoice === "veg"
                                              ? "bg-green-50 border-green-600 text-green-700"
                                              : "bg-white  text-gray-600 border-[#eaeaea] hover:border-gray-200 "
                                          }
                                    text-[12px] sm:text-sm md:text-base
                                        `}
                            >
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <rect
                                  x="1"
                                  y="1"
                                  width="14"
                                  height="14"
                                  stroke="#0F8A65"
                                  strokeWidth="1.5"
                                  fill="none"
                                />
                                <circle cx="8" cy="8" r="4" fill="#0F8A65" />
                              </svg>
                              <span>Veg</span>
                            </button>
                            <button
                              onClick={() =>
                                setSelectedchoice(
                                  selectedchoice === "non-veg"
                                    ? null
                                    : "non-veg",
                                )
                              }
                              className={`
               flex items-center gap-0.5 sm:gap-1 md:gap-2 
                          px-2 py-0.5 sm:px-2.5 sm:py-1 md:px-3 md:py-1.5 lg:px-4 lg:py-2 whitespace-nowrap
                                  rounded-full font-medium transition-all border-[1px] text-[10px] sm:text-[11px] md:text-xs lg:text-sm
            ${
              selectedchoice === "non-veg"
                ? "bg-red-50 border-red-600 text-red-700"
                : "bg-white  text-gray-600 border-[#eaeaea] hover:border-gray-200 "
            }
       text-[12px] sm:text-sm md:text-base
          `}
                            >
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <rect
                                  x="1"
                                  y="1"
                                  width="14"
                                  height="14"
                                  stroke="#E74C3C"
                                  strokeWidth="1.5"
                                  fill="none"
                                />
                                <circle cx="8" cy="8" r="4" fill="#E74C3C" />
                              </svg>
                              <span>Non-Veg</span>
                            </button>
                          </div>
                        )}
                      </div>

                      {/* grid px-9 gap-8 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3  2xl:grid-cols-4   mb-12 pb-8 Items Grid */}
                      {/* Items Grid - compact rows, images commented out below so more items fit per viewport */}
                      <div
                        className="grid px-3 sm:px-4 md:px-6 lg:px-9 
                  gap-2 sm:gap-2.5 md:gap-3 lg:gap-4 
                  grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 
                  mb-6 sm:mb-8 md:mb-12 pb-4 sm:pb-6 md:pb-8"
                      >
                        {items.map((item) => {
                          const isCustom =
                            item.customize && item.customize.length > 0;

                          const cartEntry = cart.find(
                            (c) =>
                              c.itemId === item._id &&
                              (!c.customOptions ||
                                c.customOptions.length === 0),
                          );

                          const quantity = cartEntry?.quantity || 0;
                          const cartId = cartEntry?.cartId;

                          const totalQty = getItemQty(item._id);

                          const handlePlusClick = () => {
                            handlecust(item);
                          };

                          return (
                            <div
                              key={item._id}
                              data-item-id={item._id}
                              data-item-category={item.category}
                              className="bg-white rounded-2xl cursor-pointer flex items-center justify-between 
                                   gap-2 sm:gap-3 p-2.5 sm:p-3 md:p-3.5 border border-black/5"
                              role="button"
                              tabIndex={0}
                              onClick={() => handlecust(item)}
                            >
                              <div className="flex-1 flex flex-col justify-center gap-0.5 sm:gap-1 min-w-0">
                                <div className="flex items-center gap-1.5 min-w-0">
                                  {item.foodType !== "both" && (
                                    <img
                                      src={
                                        item.foodType === "veg"
                                          ? vegIcon
                                          : nonvegIcon
                                      }
                                      alt={item.foodType}
                                      className="w-3 h-3 sm:w-3.5 sm:h-3.5 flex-shrink-0"
                                    />
                                  )}
                                  <h3 className="text-[13px] sm:text-[14px] md:text-[15px] font-bold text-[rgba(0,0,0,1)] m-0 truncate">
                                    {item.name}
                                  </h3>
                                </div>
                                <div className="flex items-center m-0">
                                  <span className="text-[13px] sm:text-[14px] font-bold text-[rgba(0,0,0,1)]">
                                    {currencySymbol}{item.price.toFixed(2)}
                                  </span>
                                </div>
                                {/* Description hidden to keep cards compact so more items fit per viewport
                                <p className="text-[11px] sm:text-[12px] md:text-[13px] lg:text-[12px] 
                            font-normal text-[rgba(0,0,0,1)] m-0 line-clamp-2 hidden sm:block">
                                  {item.description
                                    ? item.description
                                        .split(" ")
                                        .slice(0, 10)
                                        .join(" ") +
                                      (item.description.split(" ").length > 10
                                        ? "..."
                                        : "")
                                    : ""}
                                </p>
                                */}
                              </div>
                              <div className="flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                                {/* Item image intentionally hidden to fit more items on a single viewport
                                <div className="relative">
                                  <div
                                    className="h-20 w-20 sm:h-24 sm:w-24 md:h-28 md:w-28 lg:h-32 lg:w-32 
                              border-[0px] border-[rgba(0,0,0,0.1)] flex items-center 
                              justify-center rounded-[15px] sm:rounded-[18px] md:rounded-[20px] lg:rounded-[25px]"
                                  >
                                    <img
                                      src={item.imageUrl || "/placeholder.png"}
                                      alt={item.name}
                                      className="h-full w-full rounded-[10px] sm:rounded-[12px] md:rounded-[15px] 
                                  object-cover"
                                      onError={(e) => {
                                        (
                                          e.currentTarget as HTMLImageElement
                                        ).src = "/placeholder.png";
                                      }}
                                    />
                                    {item.foodType !== "both" && (
                                      <img
                                        src={
                                          item.foodType === "veg"
                                            ? vegIcon
                                            : nonvegIcon
                                        }
                                        alt={item.foodType}
                                        className="absolute -top-[10px] -right-[5px] sm:-top-[12px] sm:-right-[6px] 
                                  md:-top-[13px] md:-right-[10px] 
                                  w-3 h-3 sm:w-3.5 sm:h-3.5 md:w-4 md:h-4"
                                      />
                                    )}
                                  </div>
                                </div>
                                */}
                                {totalQty === 0 ? (
                                  <button
                                    className="bg-[#2563eb] px-2.5 py-1 sm:px-3 sm:py-1.5 md:px-4 md:py-2 
                                    rounded-[6px] sm:rounded-[8px] 
                                    text-[11px] sm:text-[12px] md:text-[13px] font-semibold text-white hover:bg-[#1d4ed8]"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handlecust(item);
                                    }}
                                  >
                                    Add +
                                  </button>
                                ) : (
                                  <div
                                    className="inline-flex items-center gap-1.5 bg-[#f5f5f5] rounded-[8px] px-1.5 py-1"
                                    onClick={(e) => e.stopPropagation()}
                                    role="group"
                                    aria-label={`Quantity controls for ${item.name}`}
                                  >
                                    <button
                                      className="w-6 h-6 rounded-[6px] border-none bg-white font-bold cursor-pointer flex items-center justify-center"
                                      onClick={() => {
                                        // Find the most recently added item (customized or not)
                                        const allItemVariants = cart.filter(
                                          (c) => c.itemId === item._id,
                                        );

                                        if (allItemVariants.length === 0)
                                          return;

                                        // Get the last added variant
                                        const lastVariant =
                                          allItemVariants[
                                            allItemVariants.length - 1
                                          ];

                                        if (lastVariant.quantity <= 1) {
                                          removeFromCart(
                                            lastVariant.cartId,
                                          );
                                        } else {
                                          updateQuantity(
                                            lastVariant.cartId,
                                            lastVariant.quantity - 1,
                                          );
                                        }
                                      }}
                                    >
                                      −
                                    </button>

                                    <span className="qty-count text-[12px] sm:text-[13px] font-semibold">
                                      {String(totalQty)}
                                    </span>

                                    <button
                                      className="w-6 h-6 rounded-[6px] border-none bg-[#2563eb] text-white font-bold cursor-pointer flex items-center justify-center"
                                      onClick={handlePlusClick}
                                    >
                                      +
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                },
              )}
            </div>
          )}
        </div>

        {/* Cart Section */}
        {/* Overlay for mobile */}
        <div
          className={`fixed inset-0 bg-black/40 z-[1000] opacity-0 pointer-events-none 
        transition-opacity duration-300 ease-in-out lg:hidden
        ${mobileCartVisible ? "opacity-100 pointer-events-auto" : ""}`}
          onClick={() => setMobileCartVisible(false)}
        ></div>
        {/* Cart Container */}
        <div
          className={`flex flex-col bg-white border-l border-gray-200 h-screen fixed top-0 right-0 transition-transform duration-300 z-[1001]
  min-[1024px]:w-[300px] min-[1024px]:static min-[1024px]:translate-x-0 min-[1024px]:pointer-events-auto
  ${
    mobileCartVisible
      ? "w-[75%] max-w-[320px] translate-x-0 shadow-[-4px_0_16px_rgba(0,0,0,0.18)]"
      : "w-[75%] max-w-[320px] translate-x-full pointer-events-none"
  }`}
        >
          {/* Close button for mobile only
        <button
          className="lg:hidden absolute top-[13px] right-[5px] text-[1.5rem] 
           bg-transparent border-none cursor-pointer text-gray-800"
          onClick={() => setMobileCartVisible(false)}
        >
          &times;
        </button> */}
          <div className="flex items-center justify-between px-4 py-2.5 border-b border-gray-200">
            <span className="font-bold text-base text-gray-900">Order</span>
            <div className="flex items-center gap-2">
              <button
                aria-label="Printer settings"
                onClick={() => {
                  setShowPrinterSettings(true);
                  setMobileCartVisible(false);
                }}
                className="bg-transparent border-0 p-1.5 rounded-lg text-gray-500 hover:text-black flex items-center justify-center"
              >
                <Printer size={16} />
              </button>
              <button
                className="text-xs text-red-500 font-semibold hover:text-red-700 disabled:text-gray-300 transition-colors"
                disabled={cart.length === 0}
                onClick={() => setOrderData((prev) => ({ ...prev, items: [] }))}
              >
                Clear
              </button>
            </div>
          </div>
          <div className="cart-body px-1 py-1 no-scrollbar">
            {cart.length === 0 ? (
              <div className="flex items-center justify-center h-full text-gray-500 font-medium">
                Your cart is empty
              </div>
            ) : (
              <div className="space-y-1">
                {cart.map((cartItem) => (
                  <div
                    className="flex items-center bg-white p-2 rounded-lg border border-[rgba(238,238,238,1)] w-full cursor-pointer"
                    key={cartItem.cartId || cartItem._id || cartItem.itemId}
                    onClick={(e) => {
                      e.stopPropagation();
                      const menuItem = menuItems.find(
                        (m) => m._id === cartItem.itemId,
                      );
                      setCustomizingItem(cartItem);
                      setSelectedCustomizeItem(menuItem || null);
                      const populated = buildSelectionsFromOptions(
                        menuItem,
                        cartItem.customOptions || [],
                      );
                      setCustomSelections(populated);
                      setShowcustModal(true);
                    }}
                  >
                    <div className="flex items-center gap-2 w-full">
                      <img
                        src={cartItem.imageUrl || "/placeholder.png"}
                        alt={cartItem.name}
                        className="w-12 h-12 object-contain rounded-md border border-gray-100 flex-shrink-0"
                        onError={(e) => {
                          (e.currentTarget as HTMLImageElement).src =
                            "/placeholder.png";
                        }}
                      />
                      <div className="flex flex-col w-full min-w-0">
                        <span className="text-gray-900 text-sm font-semibold leading-snug line-clamp-2">
                          {cartItem.name}
                          {(() => {
                            const menuItem = menuItems.find(
                              (m) => m._id === cartItem.itemId,
                            );
                            return (
                              menuItem &&
                              menuItem.foodType !== "both" && (
                                <img
                                  src={
                                    menuItem.foodType === "veg"
                                      ? vegIcon
                                      : nonvegIcon
                                  }
                                  alt={menuItem.foodType}
                                  className="inline-block w-3 h-3 ml-1"
                                />
                              )
                            );
                          })()}
                        </span>
                        {cartItem.customOptions &&
                          cartItem.customOptions.length > 0 && (
                            <div className="mt-0.5 text-xs text-gray-500 line-clamp-2">
                              {cartItem.customOptions.filter((opt) => opt.qty > 0).length > 0 && (
                                <span>
                                  {cartItem.customOptions
                                    .filter((opt) => opt.qty > 0)
                                    .map((opt) => `${opt.label}${opt.qty > 1 ? ` ×${opt.qty}` : ""}`)
                                    .join(", ")}
                                </span>
                              )}
                              {cartItem.customOptions.filter((opt) => opt.qty < 0).length > 0 && (
                                <span className="text-red-400">
                                  {cartItem.customOptions.filter((opt) => opt.qty > 0).length > 0 && " · "}
                                  No {cartItem.customOptions
                                    .filter((opt) => opt.qty < 0)
                                    .map((opt) => opt.label)
                                    .join(", ")}
                                </span>
                              )}
                            </div>
                          )}
                        <div className="inline-flex items-center justify-between mt-1.5">
                          <span className="text-gray-900 text-sm font-bold">
                            {currencySymbol}{Number(cartItem.price).toFixed(2)}
                          </span>
                          <div
                            className="flex items-center border border-black/10 rounded-xl"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                updateQuantity(cartItem.cartId, cartItem.quantity - 1);
                              }}
                              className="w-7 h-7 rounded-md font-bold flex items-center justify-center text-gray-700"
                            >
                              −
                            </button>
                            <span className="font-medium text-gray-800 w-5 text-center text-sm">
                              {cartItem.quantity}
                            </span>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                updateQuantity(cartItem.cartId, cartItem.quantity + 1);
                              }}
                              className="w-7 h-7 rounded-md font-bold flex items-center justify-center text-gray-700"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="cart-footer border-t flex flex-col gap-1.5 border-gray-200 p-3">
            <div className="flex justify-between text-sm font-semibold text-gray-700">
              <span>Subtotal</span>
              <span>{currencySymbol}{subtotal.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm font-semibold text-gray-700">
              <span>Taxes</span>
              <span>{currencySymbol}{totalTax.toFixed(2)}</span>
            </div>
            {discountAmount > 0 && (
              <div className="flex justify-between text-sm font-semibold text-gray-700">
                <span>Discount</span>
                <span>-{currencySymbol}{discountAmount.toFixed(2)}</span>
              </div>
            )}
            <div className="flex justify-between text-[15px] font-bold border-t border-gray-200 pt-1.5 mt-0.5">
              <span>Total</span>
              <span>{currencySymbol}{grandTotal.toFixed(2)}</span>
            </div>

            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-4">
                <label className="text-sm font-semibold text-gray-700 flex items-center gap-1.5 cursor-pointer">
                  <input
                    type="radio"
                    name="timeOption"
                    value="now"
                    checked={!isScheduled}
                    onChange={handleRadioChange}
                    className="accent-blue-600"
                  />
                  Now
                </label>
                <label className="text-sm font-semibold text-gray-700 flex items-center gap-1.5 cursor-pointer">
                  <input
                    type="radio"
                    name="timeOption"
                    value="schedule"
                    checked={isScheduled}
                    onChange={handleRadioChange}
                    className="accent-blue-600"
                  />
                  Schedule
                </label>
              </div>
              {isScheduled && (
                <div className="flex flex-col gap-1">
                  <label htmlFor="date" className="text-xs font-semibold text-gray-600">
                    Date & Time
                  </label>
                  <input
                    className="text-xs rounded-lg bg-[#fbfbf8] p-1.5 border border-gray-200 outline-none w-full"
                    type="datetime-local"
                    value={scheduledAt}
                    onChange={(e) => setScheduledAt(e.target.value)}
                    min={currentDateTime}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-col gap-1.5">
              <div className="flex flex-col gap-1">
                <label
                  className="text-xs font-semibold text-gray-600"
                  htmlFor="phoneNumber"
                >
                  Phone Number
                </label>
                <input
                  id="phoneNumber"
                  type="tel"
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                  maxLength={12}
                  placeholder="Enter phone number"
                  className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm outline-none transition-[border] duration-200 bg-[#fbfbf8]"
                />
              </div>
              <label className="text-xs font-semibold text-gray-600" htmlFor="tableToken">
                Table Token
              </label>
              {/* <select
                id="tableToken"
                value={tableToken}
                onChange={(e) =>
                  setTableToken(e.target.value ? Number(e.target.value) : "")
                }
                className="px-4 py-[0.55rem] border border-gray-300 rounded-lg 
          text-base outline-none transition-[border] duration-200 
          shadow-[0_1px_2px_rgba(0,0,0,0.03)]"
              >
                <option value="">Select table</option>
                {Array.from({ length: 20 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ))}
              </select> */}
              <div className="relative">
                <style>{spinnerStyle}</style>
                <input
                  type="number"
                  id="tableToken"
                  min="1"
                  max="20"
                  value={tableToken === "" ? "" : tableToken}
                  onChange={handleChange}
                  placeholder="0"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  onKeyDown={(e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Delete" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Tab"
                    ) {
                      e.preventDefault();
                    }
                    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                      e.preventDefault();
                    }
                  }}
                  onWheel={(e) => {
                    e.currentTarget.blur();
                  }}
                  className="w-full py-1.5 px-3 rounded-lg bg-[#fbfbf8] text-sm font-normal text-black outline-none border border-gray-200 transition-colors"
                />
              </div>
            </div>
            <button
              onClick={handleCheckout}
              className="w-full px-3 py-2.5 bg-[#2563eb] text-white border-none rounded-xl
          text-sm font-semibold cursor-pointer transition-all duration-150
          hover:bg-[#1d4ed8] active:scale-95 mt-1"
            >
              {loading ? "Processing..." : "Checkout"}
            </button>
          </div>
        </div>

        {/* Floating Cart Button for Mobile - hidden when cart is open */}
        {!mobileCartVisible && (
          <button
            className="lg:hidden fixed bottom-5 right-5 bg-blue-600 text-white
       border border-[#1d53c9] rounded-[20px]
       w-[100px] h-10 p-0 text-[16px] cursor-pointer
       shadow-[0_4px_12px_rgba(0,0,0,0.15)]
       z-[1001] transition-all duration-200 ease-in-out
       flex items-center justify-center gap-1"
            onClick={() => setMobileCartVisible(true)}
          >
            <span className="flex gap-1 items-center text-sm font-medium">
              <ShoppingCart size={16} />
              Cart ({cart.reduce((t, i) => t + i.quantity, 0)})
            </span>
          </button>
        )}

        {/* Customisable Modal */}
        {selectedCustomizeItem && (
          <Modal
            show={showcustModal}
            onHide={() => {
              setShowcustModal(false);
              setResetSelections((c) => c + 1);
              setCustomSelections({});
            }}
            dialogClassName="flex items-center justify-center h-[100vh] my-0"
            contentClassName="rounded-[20px] bg-white 
             pb-0  shadow-[0_6px_18px_rgba(0,0,0,0.12)] 
            max-w-[500px] max-h-[70vh] overflow-y-auto no-scrollbar relative"
          >
            <Modal.Body className="p-0">
              {/* Sticky Header with Image + Close Button */}
              <div className="sticky top-0 z-30 bg-white">
                <button
                  onClick={() => {
                    setShowcustModal(false);
                    setResetSelections((c) => c + 1);
                    setCustomSelections({});
                  }}
                  className="absolute top-2 right-2 bg-white/80 text-black font-bold rounded-full w-8 h-8 flex items-center justify-center shadow-md hover:bg-white"
                >
                  ✕
                </button>
              </div>
              <div className="relative">
                <img
                  src={selectedCustomizeItem.imageUrl || "/placeholder.png"}
                  alt={selectedCustomizeItem.name}
                  className="w-full object-cover"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).src =
                      "/placeholder.png";
                  }}
                />
              </div>
              <div className="p-3">
                <h3 className="font-bold text-lg  text-black mb-[10px] text-left mt-2">
                  {selectedCustomizeItem.name}
                </h3>
                <p
                  className="text-xs text-black font-outfit h-auto overflow-hidden 
                      text-ellipsis [display:-webkit-box] [-webkit-box-orient:vertical] text-left mt-2"
                >
                  {selectedCustomizeItem.description}
                </p>
                {(() => {
            const isHalfHalfPizza = selectedCustomizeItem.category
                  ?.toLowerCase()
                  .includes("pizza")
                  || selectedCustomizeItem.customize.some((grp) => grp.portionOptions);

                  return selectedCustomizeItem?.customize.map(
                    (group, gIndex) => {
                      // Per-group addon limit values
                      const freeToppingCount = group.noOfFreeToppings ?? 0;
                      const maxToppings = group.maxToppingsAllowed;
                      const minAddons = group.minAddons ?? 0;

                      const totalSelectedInGroup = group.choices.reduce((sum, c) => {
                        if (c.default) return sum;
                        const k = `${group.name}|||${c.label}`;
                        return sum + Math.max(0, Number(customSelections[k] || 0));
                      }, 0);
                      const hasReachedMaxToppings =
                        !!maxToppings &&
                        maxToppings > 0 &&
                        totalSelectedInGroup >= maxToppings;

                      // Pre-compute free quota available before each choice in this group consumes it
                      const freeBeforeChoice = new Map<string, number>();
                      if (freeToppingCount > 0) {
                        let freeRem = freeToppingCount;
                        for (const c of group.choices) {
                          if (c.default) continue;
                          const k = `${group.name}|||${c.label}`;
                          freeBeforeChoice.set(k, freeRem);
                          const qty = Number(customSelections[k] || 0);
                          if (qty > 0 && freeRem > 0) freeRem -= Math.min(qty, freeRem);
                        }
                      }

                      const hasSelection = (group.choices || []).some((choice) => {
                        const key = `${group.name}|||${choice.label}`;
                        return Number(customSelections[key] || 0) > 0;
                      });
                      const isCollapsed = collapsedGroups[group.name] ?? false;
                      return (
                      <div
                        key={gIndex}
                        ref={(el) => {
                          customizationGroupRefs.current[`group-${gIndex}`] =
                            el;
                        }}
                        className={`mb-3 border-b-2 rounded-lg p-2 transition-all duration-200 ${
                          hasAttemptedSubmit && (
                            (group.required && !hasSelection) ||
                            (minAddons > 0 && totalSelectedInGroup < minAddons)
                          )
                            ? "border-2 border-red-500"
                            : ""
                        }`}
                      >
                        <button
                          type="button"
                          className="w-full flex items-center justify-between gap-2 mb-2 cursor-pointer select-none group"
                          onClick={() =>
                            setCollapsedGroups((prev) => ({
                              ...prev,
                              [group.name]: !isCollapsed,
                            }))
                          }
                        >
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="text-base font-semibold">{group.name}</span>
                            {group.required && (
                              <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                                hasSelection ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"
                              }`}>
                                {hasSelection ? "Selected" : "Required"}
                              </span>
                            )}
                            {!group.required && freeToppingCount > 0 && (
                              <span className="text-xs font-medium px-2 py-0.5 rounded-full bg-green-100 text-green-700">
                                {Math.min(totalSelectedInGroup, freeToppingCount)}/
                                {freeToppingCount} free
                              </span>
                            )}
                            {!group.required &&
                              maxToppings !== undefined &&
                              maxToppings > 0 && (
                                <span
                                  className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                                    totalSelectedInGroup >= maxToppings
                                      ? "bg-red-100 text-red-600"
                                      : "bg-gray-100 text-gray-600"
                                  }`}
                                >
                                  {totalSelectedInGroup}/{maxToppings} max
                                </span>
                              )}
                            {/* {!group.required && minAddons > 0 && (
                              <span
                                className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                                  totalSelectedInGroup >= minAddons
                                    ? "bg-blue-100 text-blue-700"
                                    : "bg-orange-100 text-orange-600"
                                }`}
                              >
                                {totalSelectedInGroup}/{minAddons} min
                              </span>
                            )} */}
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className={`shrink-0 text-gray-400 group-hover:text-gray-600 transition-transform duration-300 ${
                              isCollapsed ? "-rotate-90" : "rotate-0"
                            }`}
                          >
                            <polyline points="6 9 12 15 18 9" />
                          </svg>
                        </button>
                        <div className={`grid transition-all duration-300 ease-in-out ${isCollapsed ? "grid-rows-[0fr]" : "grid-rows-[1fr]"}`}>
                        <div className="overflow-hidden">
                        <div className="grid grid-rows">
                          {(() => {
                            // Single selection radio (required single choice)
                            if (
                              group.multiple === false &&
                              group.required === true
                            ) {
                              return [...group.choices].sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0)).map((choice, idx) => {
                                const key = `${group.name}|||${choice.label}`;
                                const quantity =
                                  (customSelections[key] as number) || 0;
                                const selectedSection =
                                  (customSelections[
                                    `${key}_section`
                                  ] as string) || "";

                                const showHalfHalfOptions =
                                  isHalfHalfPizza &&
                                  !group.name.toLowerCase().includes("dip") &&
                                  !group.name.toLowerCase().includes("sauce") &&
                                  !group.name.toLowerCase().includes("drink") &&
                                  !group.name.toLowerCase().includes("side") &&
                                  !group.name.toLowerCase().includes("sizes") &&
                                  !group.name
                                    .toLowerCase()
                                    .includes("bake level") &&
                                  !group.name.toLowerCase().includes("base");

                                return (
                                  <div key={idx}>
                                    <div
                                      className="flex items-center p-1 gap-1 mb-1"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        group.choices.forEach((c) => {
                                          const otherKey = `${group.name}|||${c.label}`;
                                          handleChoiceChange(otherKey, 0);
                                        });
                                        handleChoiceChange(key, 1);
                                      }}
                                    >
                                      <input
                                        type="radio"
                                        name={group.name}
                                        checked={quantity === 1}
                                        onChange={() => {}}
                                        style={{ pointerEvents: "none" }}
                                        className="w-4 h-4 cursor-pointer accent-blue-600 appearance-none rounded-full border border-black checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-0 focus:ring-offset-0"
                                      />
                                      <div className="flex items-center space-x-3 w-full">
                                        {choice.image && (
                                          <img
                                            src={choice.image}
                                            alt={choice.label}
                                            className="w-14 h-14 object-cover rounded-md"
                                          />
                                        )}
                                        <div className="flex flex-row w-full justify-between">
                                          <p
                                            className="text-sm font-medium m-0 cursor-pointer"
                                          >
                                            {choice.label}
                                            {selectedSection && (
                                              <span className="text-xs text-gray-500 ml-1">
                                                -{" "}
                                                {selectedSection
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  selectedSection.slice(1)}
                                              </span>
                                            )}
                                          </p>
                                          <p className="text-sm font-medium m-0">
                                            {choice.price > 0 &&
                                              `${currencySymbol}${choice.price.toFixed(2)}`}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              });
                            }

                            // Multiple Addons - qty stepper per choice
                            if (group.multipleAddons) {
                              return group.choices.map((choice, idx) => {
                                const key = `${group.name}|||${choice.label}`;
                                const qty = (customSelections[key] as number) || 0;
                                const isMaxed = hasReachedMaxToppings;
                                return (
                                  <div key={idx} className="flex items-center justify-between p-1.5 gap-2">
                                    <div className="flex items-center gap-3">
                                      {choice.image && (
                                        <img
                                          src={choice.image}
                                          alt={choice.label}
                                          className="w-12 h-12 object-cover rounded-md"
                                        />
                                      )}
                                      <div>
                                        <p className="text-sm font-medium m-0">{choice.label}</p>
                                        {choice.price > 0 && (
                                          <p className="text-xs text-gray-500 m-0">+{currencySymbol}{choice.price.toFixed(2)}</p>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-2 shrink-0">
                                      {qty > 0 && (
                                            <>
                                              <button
                                                type="button"
                                                onClick={() => handleChoiceChange(key, qty - 1)}
                                                className="w-7 h-7 rounded-full border border-gray-300 flex items-center justify-center text-lg font-semibold hover:bg-gray-100 transition"
                                              >
                                                −
                                              </button>
                                              <span className="w-5 text-center text-sm font-semibold">{qty}</span>
                                            </>
                                          )}
                                      <button
                                        type="button"
                                        onClick={() => !isMaxed && handleChoiceChange(key, qty + 1)}
                                        disabled={isMaxed}
                                        className="w-7 h-7 rounded-full border border-gray-300 flex items-center justify-center text-lg font-semibold disabled:opacity-30 hover:bg-gray-100 transition"
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                );
                              });
                            }

                            // Multiple selection - checkboxes
                            if (group.multiple) {
                              return [...group.choices].sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0)).map((choice, idx) => {
                                const key = `${group.name}|||${choice.label}`;
                                const isChecked =
                                  ((customSelections[key] as number) || 0) > 0;
                                const isChoiceMaxedOut =
                                  hasReachedMaxToppings && !isChecked;
                                if (isChoiceMaxedOut) return null;
                                const selectedSection =
                                  (customSelections[
                                    `${key}_section`
                                  ] as string) || "";

                                // Use group's showPortionSelector setting, fallback to old logic for backward compatibility
                                const showHalfHalfOptions =
                                  isHalfHalfPizza &&
                                  (group.showPortionSelector !== undefined
                                    ? group.showPortionSelector
                                    : !group.name
                                        .toLowerCase()
                                        .includes("dip") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("sauce") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("drink") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("side") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("sizes") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("bake level") &&
                                      !group.name
                                        .toLowerCase()
                                        .includes("base"));

                                // Get portion options from group or use defaults (check for empty array too)
                                const portionOptionsMultiple = group
                                  .portionOptions?.length
                                  ? group.portionOptions
                                  : [
                                      { key: "left", label: "Left" },
                                      { key: "right", label: "Right" },
                                      { key: "whole", label: "Whole" },
                                    ];

                                return (
                                  <div key={idx}>
                                    {showHalfHalfOptions ? (
                                      // Half & Half Pizza UI with section buttons for multiple selection
                                      <div className="flex flex-col w-full space-y-2">
                                        <div className="flex items-center space-x-3">
                                          {choice.image && (
                                            <img
                                              src={choice.image}
                                              alt={choice.label}
                                              className="w-14 h-14 object-cover rounded-md"
                                            />
                                          )}
                                          <div className="flex flex-col w-full mt-1">
                                            <div className="flex flex-row w-full justify-between mb-2">
                                              <p
                                                className="text-sm font-medium m-0 cursor-pointer"
                                                onClick={() =>
                                                  handleChoiceChange(
                                                    key,
                                                    isChecked ? 0 : 1,
                                                  )
                                                }
                                              >
                                                {choice.label}
                                                {selectedSection && (
                                                  <span className="text-xs text-gray-500 ml-1">
                                                    -{" "}
                                                    {selectedSection
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                      selectedSection.slice(1)}
                                                  </span>
                                                )}
                                              </p>
                                              <p className="text-sm font-medium m-0">
                                                {choice.price > 0 &&
                                                  `${currencySymbol}${choice.price.toFixed(2)}`}
                                              </p>
                                            </div>
                                          </div>
                                        </div>

                                        {/* Pizza section buttons */}
                                        <div className="flex gap-2 mt-0">
                                          {portionOptionsMultiple.map(
                                            (option) => (
                                              <button
                                                key={option.key}
                                                onClick={() =>
                                                  handleHalfHalfSelection(
                                                    key,
                                                    option.key as
                                                      | "left"
                                                      | "right"
                                                      | "whole",
                                                  )
                                                }
                                                className={`flex items-center justify-center gap-2 px-4 py-2 rounded-xl border-2 text-sm font-semibold transition-all duration-200 min-w-[80px] shadow-sm ${
                                                  selectedSection === option.key
                                                    ? "border-blue-600 bg-gradient-to-r from-blue-50 to-blue-100 text-blue-800 shadow-md scale-105"
                                                    : "border-gray-300 bg-white text-gray-700 hover:border-blue-300 hover:bg-blue-50 hover:shadow-md transform hover:scale-105"
                                                }`}
                                              >
                                                {PizzaIcons[
                                                  option.key as keyof typeof PizzaIcons
                                                ] || null}
                                                <span className="font-bold">
                                                  {option.label}
                                                </span>
                                              </button>
                                            ),
                                          )}
                                        </div>
                                      </div>
                                    ) : (
                                      // Regular checkbox UI for non-Half & Half items
                                      <div className="flex items-center p-1 gap-1">
                                        <label className="relative flex items-center cursor-pointer">
                                          <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={() =>
                                              handleChoiceChange(
                                                key,
                                                isChecked ? 0 : 1,
                                              )
                                            }
                                            className="w-4 h-4 cursor-pointer accent-blue-600 rounded border border-gray-300 focus:outline-none focus:ring-0"
                                          />
                                          <svg
                                            className="absolute w-3 h-3 text-white pointer-events-none left-[3px] top-[3px] opacity-0 peer-checked:opacity-100"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="white"
                                          >
                                            <path
                                              fillRule="evenodd"
                                              d="M16.707 5.293a1 1 0 010 1.414l-7.364 7.364a1 1 0 01-1.414 0L3.293 9.414a1 1 0 011.414-1.414l4.121 4.121 6.657-6.657a1 1 0 011.414 0z"
                                              clipRule="evenodd"
                                            />
                                          </svg>
                                        </label>

                                        <div className="flex items-center w-full space-x-3">
                                          {choice.image && (
                                            <img
                                              src={choice.image}
                                              alt={choice.label}
                                              className="w-14 h-14 object-cover rounded-md"
                                            />
                                          )}
                                          <div className="flex flex-row w-full justify-between">
                                            <p
                                              className="text-sm font-medium m-0 cursor-pointer"
                                              onClick={() =>
                                                handleChoiceChange(
                                                  key,
                                                  isChecked ? 0 : 1,
                                                )
                                              }
                                            >
                                              {choice.label}
                                            </p>
                                            <p className="text-sm font-medium m-0">
                                              {choice.price > 0 &&
                                                `${currencySymbol}${choice.price.toFixed(2)}`}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              });
                            }

                            // Default: quantity selection (number buttons) - Optional selections
                            return [...group.choices].sort((a, b) => (b.default ? 1 : 0) - (a.default ? 1 : 0)).map((choice, idx) => {
                              const key = `${group.name}|||${choice.label}`;
                              const quantity =
                                (customSelections[key] as number) || 0;
                              const isHiddenByMax =
                                !choice.default &&
                                hasReachedMaxToppings &&
                                quantity === 0;
                              if (isHiddenByMax) return null;
                              const selectedSection =
                                (customSelections[
                                  `${key}_section`
                                ] as string) || "";

                              // Use group's showPortionSelector setting, fallback to old logic for backward compatibility
                              const showHalfHalfOptions =
                                isHalfHalfPizza &&
                                (group.showPortionSelector !== undefined
                                  ? group.showPortionSelector
                                  : !group.name.toLowerCase().includes("dip") &&
                                    !group.name
                                      .toLowerCase()
                                      .includes("sauce") &&
                                    !group.name
                                      .toLowerCase()
                                      .includes("drink") &&
                                    !group.name
                                      .toLowerCase()
                                      .includes("side") &&
                                    !group.name
                                      .toLowerCase()
                                      .includes("bake level") &&
                                    !group.name
                                      .toLowerCase()
                                      .includes("sizes") &&
                                    !group.name.toLowerCase().includes("base"));

                              // Get quantity options from group or use defaults (check for empty array too)
                              const quantityOptions = group.quantityOptions
                                ?.length
                                ? group.quantityOptions
                                : [0, 1, 2, 3];
                              const isDefaultWithOffset =
                                choice.default && quantityOptions[0] < 0;
                              const showPortionForChoice = isDefaultWithOffset
                                ? quantity >= 0
                                : quantity > 0;
                              // Get portion options from group or use defaults (check for empty array too)
                              const portionOptions = group.portionOptions
                                ?.length
                                ? group.portionOptions
                                : [
                                    { key: "left", label: "Left" },
                                    { key: "right", label: "Right" },
                                    { key: "whole", label: "Whole" },
                                  ];

                              if (choice.default) {
                                return (
                                  <div key={idx}>
                                    <div className="flex items-center space-x-3 mb-2">
                                      {choice.image && (
                                        <img
                                          src={choice.image}
                                          alt={choice.label}
                                          className="w-14 h-14 object-cover border-[1.5px] border-gray-300 rounded-md"
                                        />
                                      )}
                                      <div className="flex flex-col w-full">
                                        <div className="flex flex-row w-full justify-between">
                                          <p className="text-sm font-semibold line-clamp-2 mb-0">
                                            {choice.label}
                                            {selectedSection &&
                                              showPortionForChoice && (
                                                <span className="text-xs text-gray-500 ml-1">
                                                  -{" "}
                                                  {selectedSection
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                    selectedSection.slice(1)}
                                                </span>
                                              )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Quantity buttons */}
                                    <div className="flex items-center gap-3 flex-wrap mb-3">
                                      {quantityOptions.map((num, btnIdx) => {
                                        // For default choices: if first option is negative (like -1), treat as "remove"
                                        const actualQuantity =
                                          choice.default && !isDefaultWithOffset
                                            ? num === 0
                                              ? -1
                                              : num
                                            : num;
                                        const displayNum = isDefaultWithOffset
                                          ? btnIdx
                                          : num;
                                        const chargeableQty = choice.default
                                          ? isDefaultWithOffset
                                            ? Math.max(0, actualQuantity)
                                            : Math.max(0, actualQuantity - 1)
                                          : Math.max(0, actualQuantity);
                                        const additionalPrice =
                                          chargeableQty * (choice.price || 0);
                                        const isSelected =
                                          quantity === actualQuantity;

                                        return (
                                          <button
                                            key={num}
                                            onClick={() =>
                                              handleChoiceChange(
                                                key,
                                                actualQuantity,
                                              )
                                            }
                                            className={`grid place-items-center rounded-lg border transition-all w-[70px] h-[50px] ${
                                              isSelected
                                                ? "border-blue-600 bg-blue-50"
                                                : "border-gray-300 bg-white hover:border-gray-400"
                                            }`}
                                          >
                                            <div className="flex flex-col items-center justify-center">
                                              <span className="text-lg font-bold leading-none">
                                                {displayNum}
                                              </span>
                                              {additionalPrice > 0 && (
                                                <span className="text-xs text-gray-600 mt-1">
                                                  +{currencySymbol}{additionalPrice.toFixed(2)}
                                                </span>
                                              )}
                                            </div>
                                          </button>
                                        );
                                      })}
                                    </div>

                                    {/* Half & Half options for default choices when quantity > 0 */}
                                    {showHalfHalfOptions &&
                                      showPortionForChoice && (
                                        <div>
                                          <div className="flex mb-4 border-2 border-gray-300 rounded-lg overflow-hidden w-fit">
                                            {portionOptions.map(
                                              (option, index) => (
                                                <div
                                                  key={option.key}
                                                  className={`flex ${
                                                    index !==
                                                    portionOptions.length - 1
                                                      ? "border-r border-gray-300"
                                                      : ""
                                                  }`}
                                                >
                                                  <button
                                                    onClick={() =>
                                                      handleHalfHalfSelection(
                                                        key,
                                                        option.key as
                                                          | "left"
                                                          | "right"
                                                          | "whole",
                                                      )
                                                    }
                                                    className={`flex flex-col items-center justify-center gap-1 px-4 py-2 text-xs font-semibold transition-all duration-200 min-w-[70px]
              ${
                selectedSection === option.key
                  ? "bg-gradient-to-r from-blue-50 to-blue-100 text-blue-800 scale-105 border-x border-gray-300"
                  : "bg-white text-gray-700 hover:bg-blue-50 hover:scale-105 hover:border-x border-gray-300"
              }`}
                                                  >
                                                    {PizzaIcons[
                                                      option.key as keyof typeof PizzaIcons
                                                    ] || null}
                                                    <span className="font-bold">
                                                      {option.label}
                                                    </span>
                                                  </button>
                                                </div>
                                              ),
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                );
                              }

                              return (
                                <div
                                  key={idx}
                                  className="my-2"
                                >
                                  <div className="flex items-center space-x-3 mb-2">
                                    {choice.image && (
                                      <img
                                        src={choice.image}
                                        alt={choice.label}
                                        className="w-14 h-14 object-cover border-[1.5px] border-gray-300 rounded-md"
                                      />
                                    )}
                                    <div className="flex flex-col w-full mt-1">
                                      <div className="flex flex-row w-full justify-between">
                                        <p className="text-sm font-semibold line-clamp-2 mb-0">
                                          {choice.label}
                                          {selectedSection &&
                                            showPortionForChoice && (
                                              <span className="text-xs text-gray-500 ml-1">
                                                -{" "}
                                                {selectedSection
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  selectedSection.slice(1)}
                                              </span>
                                            )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Quantity buttons for non-default choices */}
                                  <div className="flex items-center gap-3 flex-wrap mb-3">
                                    {quantityOptions.map((num) => {
                                      const actualQuantity = num; // use num directly for non-default
                                      const isDefaultWithOffset =
                                        choice.default &&
                                        quantityOptions[0] < 0;
                                      const chargeableQty = choice.default
                                        ? isDefaultWithOffset
                                          ? Math.max(0, actualQuantity)
                                          : Math.max(0, actualQuantity - 1)
                                        : Math.max(0, actualQuantity);
                                      const availableFreeForChoice = freeBeforeChoice.get(key) ?? 0;
                                      const freeUnits = Math.min(chargeableQty, availableFreeForChoice);
                                      const displayPrice = (chargeableQty - freeUnits) * (choice.price || 0);
                                      const isFreeButton = chargeableQty > 0 && freeUnits >= chargeableQty;
                                      const isSelected =
                                        quantity === actualQuantity;
                                      const isButtonDisabled =
                                        !!maxToppings &&
                                        num > 0 &&
                                        totalSelectedInGroup - quantity + num > maxToppings;

                                      return (
                                        <button
                                          key={num}
                                          disabled={isButtonDisabled}
                                          onClick={() => {
                                            if (!isButtonDisabled) handleChoiceChange(key, actualQuantity);
                                          }}
                                          className={`grid place-items-center rounded-lg border transition-all w-[70px] h-[50px] ${
                                            isButtonDisabled
                                              ? "border-black/10 bg-gray-50 text-black/20 cursor-not-allowed"
                                              : isSelected
                                                ? "border-blue-600 bg-blue-50"
                                                : "border-gray-300 bg-white hover:border-gray-400"
                                          }`}
                                        >
                                          <div className="flex flex-col items-center justify-center">
                                            <span className="text-lg font-bold leading-none">
                                              {num}
                                            </span>
                                            {!isFreeButton && displayPrice > 0 ? (
                                              <span className={`text-xs mt-1 ${isSelected ? "text-blue-600" : "text-gray-600"}`}>
                                                +{currencySymbol}{displayPrice.toFixed(2)}
                                              </span>
                                            ) : null}
                                          </div>
                                        </button>
                                      );
                                    })}
                                  </div>

                                  {/* Half & Half options for non-default choices when quantity > 0 */}
                                  {showHalfHalfOptions &&
                                    showPortionForChoice && (
                                      <div>
                                        <div className="flex mb-4 border-2 border-gray-300 rounded-lg overflow-hidden w-fit">
                                          {portionOptions.map(
                                            (option, index) => (
                                              <div
                                                key={option.key}
                                                className={`flex ${
                                                  index !==
                                                  portionOptions.length - 1
                                                    ? "border-r border-gray-300"
                                                    : ""
                                                }`}
                                              >
                                                <button
                                                  onClick={() =>
                                                    handleHalfHalfSelection(
                                                      key,
                                                      option.key as
                                                        | "left"
                                                        | "right"
                                                        | "whole",
                                                    )
                                                  }
                                                  className={`flex flex-col items-center justify-center gap-1 px-4 py-2 text-xs font-semibold transition-all duration-200 min-w-[70px]
              ${
                selectedSection === option.key
                  ? "bg-gradient-to-r from-blue-50 to-blue-100 text-blue-800 scale-105 border-x border-gray-300"
                  : "bg-white text-gray-700 hover:bg-blue-50 hover:scale-105 hover:border-x border-gray-300"
              }`}
                                                >
                                                  {PizzaIcons[
                                                    option.key as keyof typeof PizzaIcons
                                                  ] || null}
                                                  <span className="font-bold">
                                                    {option.label}
                                                  </span>
                                                </button>
                                              </div>
                                            ),
                                          )}
                                        </div>
                                      </div>
                                    )}
                                </div>
                              );
                            });
                          })()}
                        </div>
                        </div>
                        </div>
                      </div>
                    );
                  });
                })()}
              </div>
            </Modal.Body>

            <Modal.Footer className="sticky bottom-0 bg-white m-0">
              {/* Left side: Total */}
              <div className="flex justify-between w-full items-center">
                <div className="text-lg font-semibold">
                  Total: {currencySymbol}
                  {(
                    (selectedCustomizeItem?.price || 0) +
                    Math.max(0,
                      Object.entries(customSelections).reduce(
                        (acc, [key, quantity]) => {
                          if (key.endsWith("_section")) return acc;
                          const [groupName, choiceLabel] = key.split("|||");
                          const group = selectedCustomizeItem?.customize.find(
                            (g) => g.name === groupName,
                          );
                          const choice = group?.choices.find(
                            (c) => c.label === choiceLabel,
                          );
                          const qty = quantity as number;
                          if (qty <= 0) return acc;
                          const quantityOptions = group?.quantityOptions?.length
                            ? group.quantityOptions
                            : [0, 1, 2, 3];
                          const hasDefaultOffset =
                            !!choice?.default && quantityOptions[0] < 0;
                          const chargeableQty = choice?.default
                            ? hasDefaultOffset
                              ? Math.max(0, qty)
                              : Math.max(0, qty - 1)
                            : qty;
                          return acc + (choice?.price || 0) * chargeableQty;
                        },
                        0,
                      ) -
                      (selectedCustomizeItem
                        ? computeFreeToppingDiscount(selectedCustomizeItem, customSelections as Record<string, number | string>)
                        : 0)
                    )
                  ).toFixed(2)}
                </div>
                <div
                  className={`text-center text-white px-3 py-1 rounded-md font-semibold ${
                    isCustomizationValid
                      ? "cursor-pointer bg-[#2563eb] hover:bg-[#1d4ed8]"
                      : "cursor-pointer bg-gray-400"
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isCustomizationValid) {
                      setHasAttemptedSubmit(true);
                      focusFirstMissingRequiredGroup();
                      return;
                    }
                    setHasAttemptedSubmit(false);
                    handleCustomSubmit();
                  }}
                >
                  Add to Cart
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </div>
      {showPrinterSettings && (
        <PrinterSettings onClose={() => setShowPrinterSettings(false)} />
      )}
    </div>
  );
};

export default EmpPos;
